import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

export interface IExternalPartyFull {
  id: string
  businessId: string
  name: string
  type: string
  taxId: string | null
  contactName: string | null
  contactPhone: string | null
  altContactPhone: string | null
  address: string | null
  city: string | null
  district: string | null
  subDistrict: string | null
  latitude: string | null
  longitude: string | null
  businessHours: Record<string, unknown> | null
  notes: string | null
  isActive: boolean
  createdByUserId: string
  createdAt?: string
  updatedAt?: string
}

export interface IExternalPartiesFullResponse {
  rows: IExternalPartyFull[]
  count: number
}

export interface ICreateExternalPartyInput {
  name: string
  type?: string
  taxId?: string | null
  contactName?: string | null
  contactPhone?: string | null
  altContactPhone?: string | null
  address?: string | null
  city?: string | null
  district?: string | null
  subDistrict?: string | null
  latitude?: string | null
  longitude?: string | null
  businessHours?: Record<string, unknown> | null
  notes?: string | null
  isActive?: boolean
}

export const create = async (data: ICreateExternalPartyInput): Promise<IExternalPartyFull> =>
  httpRequest.post("/ord/external-party", data as any)

export const list = async (data: {
  filter?: { search?: string; isActive?: boolean; type?: string }
  offset?: { limit: number; skip: number }
  order?: Array<[string, string]>
}): Promise<IExternalPartiesFullResponse> =>
  httpRequest.post("/ord/external-party/list", data as any)

export const get = async (id: string): Promise<IExternalPartyFull> =>
  httpRequest.get(`/ord/external-party/${id}`)

export const update = async (
  id: string,
  patch: Partial<ICreateExternalPartyInput>,
): Promise<IExternalPartyFull> =>
  httpRequest.put(`/ord/external-party/${id}`, patch as any)

export const remove = async (id: string): Promise<{ removed: boolean; reason?: string }> =>
  httpRequest.del(`/ord/external-party/${id}`)
